<div class="example_outer_section">
    <div class="example_top_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h1>A Trinka oferece aprimoramento de escrita completa</h1>
                    <p>Projetado para ajudar acadêmicos e escritores técnicos, a Trinka verifica sua escrita não apenas para a gramática, mas também para necessidades avançadas de escrita que são essenciais para uma comunicação eficaz.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="exapmle_cards_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>Verificações gramaticais avançadas para escrita sem erros</h3>
                    <p>A escrita acadêmica e técnica apresentam erros de escrita peculiares que outras ferramentas não capturam. A Trinka vem em seu resgate!</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>Discordância sujeito-verbo</h4>
                        <p>Therefore, these results suggest that the hypersecretion of CRH and endorphin
                            <span>suppress</span>
                            <span class="right_word">suppresses</span> the secretion of LH and FSH from the pituitary gland.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>Escolha da palavra</h4>
                        <p>The statistical analyses were performed <span>with</span> <span class="right_word">using</span> a statistical analysis software (SAS).</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>Preposição</h4>
                        <p>Recent years have seen an increase <span>of</span> <span class="right_word">in</span> exudation of various organic acids.</p>
                    </div>
                </div>

                <!-- <div class="col-md-12">
                    <div class="example_box_contents">
                        <h4>Subject-verb disagreement</h4>
                        <p><span>Trinka</span> is your personal <span>AI editor</span> for all your academic writing
                            needs. <span>Trinka</span> is your personal <span>AI editor</span> for all your academic
                            writing needs.</p>
                    </div>
                </div> -->

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>Uso de adjetivo</h4>
                        <p>The group receiving the placebo treatment had the <span>most</span> highest improvement in sleep scores.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->

    <div class="exapmle_cards_heading background_color_changes">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>Melhorias para escrita padrão de publicação</h3>
                    <p>Com verificações que melhoram o tom, o estilo e a adesão aos guias de estilo padrão, o Trinka ajuda você a tornar sua escrita adequada para o público acadêmico.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs boxs_margin background_color_changes">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>Concisão</h4>
                        <p>Utilities would continue to <span>have the obligation</span> <span class="right_word">be
                                obliged</span> to serve retail customers.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>Escolha da palavra</h4>
                        <p>The <span>average</span> <span class="right_word">mean</span> age of the study group was 54.2 years (range: 8-90 years).</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>Tom formal</h4>
                        <p>The assembly <span>abrogated</span> <span class="right_word">arrogated</span> to itself the right to make changes.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>Escolha da palavra</h4>
                        <p>Substance <span>abuse</span> <span class="right_word">use disorder</span> has been a major public health concern.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->


    <div class="exapmle_cards_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>Controles específicos para correcções precisas</h3>
                    <p>A Trinka entende que cada sujeito tem uma expressão única. Ele garante que as correções não alterem o estilo específico da sua área de assunto.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs boxs_margin">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>Ciência da computação</h4>
                        <p>In our study, 90% of the users expressed the need for a <span>dialogue</span> <span class="right_word">dialog</span> box to alert them to a pending update.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>Física</h4>
                        <p>By contrast, the <span>effect</span> <span class="right_word">effects</span> of the Mach number and <span class="">heat</span> specific <span class="right_word">heat</span> ratio contribute little to the aerodynamic performance.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>Medicina</h4>
                        <p>Our study matched for age, <span>gender</span> <span class="right_word">sex</span>, ethnicity, and BMI, marijuana use was associated with higher abdominal visceral fat.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>Economia</h4>
                        <p>The estimated natural rate, based on the <span>past</span> history of the data, plummets by nearly 2
                            <span>percent</span> <span class="right_word">percentage</span> points.
                        </p>
                        <!-- <p>Studies have shown that organizational culture and <span>organizational</span> environment
                            now meet work-life policies.
                        </p> -->
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->


</div>